package de.emgress.baskets.modules.schedule

import androidx.compose.runtime.Composable
import de.emgress.baskets.core.styles.Styles
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun TeamComponent(
    name: String,
    logoUrl: String?,
    isHomeTeam: Boolean
) {
    Div({
        classes(Styles.cssClasses.column, Styles.cssClasses.scheduleTeamLogoContainer)
        style {
            justifyContent(JustifyContent.Start)
            if (isHomeTeam) {
                alignItems(AlignItems.FlexEnd)
            } else {
                alignItems(AlignItems.FlexStart)
            }
        }
    }) {
        logoUrl?.let {
            Img(
                attrs = {
                    classes(Styles.cssClasses.scheduleTeamLogo)
                },
                src = it
            )
        }
        P(attrs = {
            classes(Styles.cssClasses.teamName, Styles.cssClasses.bold, Styles.cssClasses.barlowFont)
            style {
                if (isHomeTeam) {
                    textAlign("right")
                } else {
                    textAlign("left")
                }
                flex(1)
            }
        }) {
            Text(name)
        }
    }
}